<template>
  <v-main>
    <v-snackbar
      v-model="snackbar"
      :vertical="false"
      :timeout="timeout"
      top="top"
      :color="tipo"
      elevation="5"
      multi-line
      right
      shaped
    >
      {{ mensagem }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">OK</v-btn>
      </template>
    </v-snackbar>
    <v-row class="pa-0 ma-0">
      <v-col cols="12" sm="8" xl="9" class="pa-0 ma-0 lado-esquerdo">
        <div class="logo">
          <v-img src="../../assets/img/logo-controle-produtividade-comp.png"></v-img>
        </div>
      </v-col>
      <v-col cols="12" sm="4" xl="3" class="px-10 container-form-direita">
        <v-row>
          <v-col cols="12">
            <form class="pa-5 form-direita" autocomplete="off">
              <div class="titulo-form">Login</div>
              <v-text-field
                color="primary"
                class="font-custom"
                label="Nome de usuário"
                persistent-placeholder
                v-model="usuario.login"
              ></v-text-field>
              <v-text-field
                @keyup.enter="logar"
                persistent-placeholder
                label="Senha"
                v-model="usuario.senha"
                :append-icon="value ? 'visibility_off' : 'visibility'"
                @click:append="() => (value = !value)"
                :type="value ? 'password' : 'text'"
                class="form-input"
              ></v-text-field>
              <v-btn
                color="primary"
                @click="logar"
                type="button"
                class="btn-entrar"
              >
                <v-progress-circular
                  indeterminate
                  v-if="loading"
                  color="white"
                  :size="25"
                  :width="3"
                ></v-progress-circular>
                <div v-else>Entrar</div>
              </v-btn>
            </form>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-main>
</template>
<script>

import utilsStorage from "@/utils/storage";
import mixinMensagen from "@/mixin/mixin-mensagem";
import Usuario from "@/model/usuario/Usuario";
import apiUsuario from "@/api/usuario/usuario-api";
import cripto from "@/utils/critpografia";

export default {
  name: "login",
  mixins: [mixinMensagen],
  data() {
    return {
      loading: false,
      usuario: new Usuario(),
      value: "password",
    };
  },

  methods: {
    async logar() {
      if (!this.usuario.login || !this.usuario.senha) {
        this.dispararMensagem(
          "Informe o login e senha de rede para acesso.",
          "error"
        );
        return;
      }

      this.loading = true;
      const usuarioFechado = {login:cripto.criptografar(this.usuario.login), senha:cripto.criptografar(this.usuario.senha)};
      await apiUsuario
        .logar(usuarioFechado)
        .then((response) => {
          this.loading = false;
          this.salvarInformacoesLocalStorage(
            response.data,
            response.data.token
          );
          this.$router.push({ name: "Dashboard" });
        })
        .catch((error) => {
          this.dispararMensagem(
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message) ||
              "Não foi possível se comunicar com o servidor!",
            "error"
          );
          utilsStorage.removerAutenticacao();
          this.loading = false;
        });
    },

    salvarInformacoesLocalStorage(usuario, token) {
      utilsStorage.salvarTokenNaStorage(token);
      utilsStorage.salvarUsuarioNaStorage(usuario);
    },
  },
};
</script>

<style lang="scss" scoped>
div {
  width: 100%;
}

.box-login {
  background-color: $white;
  width: 800px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 120px;

  padding: 40px;
  padding-bottom: 60px;
  border-radius: 5px;
}

.lado-esquerdo {
  height: 100vh;
  background: url("../../assets/img/imagem-login-comp.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.logo {
  width: 55%;
  display: flex;
}

@media screen and (min-width: 2000px) {
  .logo {
    width: 35%;
  }
}

.container-form-direita {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.form-direita {
  margin-bottom: 60px;
}

.titulo-form {
  text-align: center;
  font-size: 30px;
  font-weight: 600;
  color: $grey-700;
  margin-bottom: 16px;
}

.btn-entrar {
  width: 100%;
  font-weight: 600;
  border: 1px solid #ddd;
  margin: 0;
  margin-top: 15px;
  height: 38px !important;
}

.btn-entrar:hover {
  cursor: pointer;
  background-color: rgb(217, 223, 217);
}

.btn-entrar:focus {
  outline: none;
}

.v-text-field ::v-deep label {
    font-size: 16px;
    font-weight: 500;
}
</style>